// @ts-nocheck
import {
  useEffect,
  useRef,
  useState,
  Ref,
  useMemo,
  useCallback,
  Fragment,
} from "react";
import { useNavigationStore } from "src/store/navigationStore";

import { Canvas, useFrame, RootState } from "@react-three/fiber";
import { Splat, useGLTF, useAnimations } from "@react-three/drei";
import * as THREE from "three";
import { Group } from "three";

import {
  findMapAlignWithLcMapId,
  getModelConfigMapByLcMapId,
  getAltitudeByFloorName,
  getBaseUrl,
  getMapSettingByVenueCode,
} from "src/utils/map-util";

import { useExplorationStore } from "@/store/explorationStore";

import {
  roundToDecimals,
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  angleDifferenceABtoAC,
  wrapAngle,
  getBackPositionWithDistance,
  getNewFrontPosition,
} from "src/utils/game";
import * as pc from "playcanvas";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
  useAppEvent,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
  RigidBody,
  Collision,
} from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";

import {
  createRadialScript,
  SplatLodComponent,
  SplatSogComponent,
  RobotAvatar,
  MeshModelComponent,
  FloorMeshComponent,
} from "@/components/playcanvas/playcanvasComponents";

import WatermarkScreen from "src/components/watermark";
import { useLodSplat } from "src/utils/useLodSplat";
import { findVenueFullVideo } from "@/types/supported-venue";

let globalFloorList = [];
let globalFloorShortNameList = [];
let globalCurrentFloor = "";
let globalVideo = "";

export const webviewGetFloorList = () => {
  console.log("webviewGetFloorList");
  return globalFloorList;
};
export const webviewSetFloor = (floor: string) => {
  console.log("webviewSetFloor" + floor);
  globalCurrentFloor = floor;
};
export const webviewGetFullVideo = () => {
  console.log("webviewGetFullVideo:" + globalVideo);
  return globalVideo;
};

window["WebViewAPI"] = {
  webviewGetFloorList,
  webviewSetFloor,
  webviewGetFullVideo,
};

function sendToFlutter(payload: any) {
  window.FlutterBridge?.postMessage(JSON.stringify(payload));
  console.log("sendToFlutter", payload);
}

export default function ExploreFlutter() {
  const setCameraPosition = useExplorationStore(
    (state) => state.setCameraPosition,
  );
  const setCameraLookingPosition = useExplorationStore(
    (state) => state.setCameraLookingPosition,
  );
  const setCameraAngle = useExplorationStore((state) => state.setCameraAngle);
  const setCurrentVenueName = useExplorationStore(
    (state) => state.setCurrentVenueName,
  );

  const setCurrentLcMapId = useExplorationStore(
    (state) => state.setCurrentLcMapId,
  );

  const setExploratingPosition = useExplorationStore(
    (state) => state.setExploratingPosition,
  );
  const setExploratingAngle = useExplorationStore(
    (state) => state.setExploratingAngle,
  );
  const triggerResetPositionRotationEvent = useExplorationStore(
    (state) => state.triggerResetPositionRotationEvent,
  );

  const THIRD_PERSION_DISTANCE = 4;
  const SCALE_BASE = 1500;

  const [mapSettingState, setMapSettingState] = useState<IMapAlign>(null);
  const mapSettingRef = useRef();
  const modelScaleFactorRef = useRef(1);

  const gsplatAllRef = useRef({});
  const splatDisplayFloor = useRef<number[]>();

  const moveSpeedRef = useRef<number>(1);
  const rotateSpeedRef = useRef<number>(1);
  const downSpeedRef = useRef<number>(1);

  const topPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultTargetRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));

  const targetAltitudeRef = useRef<number>(0);

  const currentLcMapIdRef = useRef<string>("");
  const isLevelChangingRef = useRef<boolean>(false);

  const mainObjectEntityRef = useRef();
  const cameraScriptRef = useRef();
  const firstPersonCameraEntityRef = useRef();
  const thirdPersonCameraEntityRef = useRef();
  const latestCameraModeRef = useRef<number>(0);

  const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const [modelLoadedState, setModelLoadedState] = useState(false);
  const [coordReadyState, setCoordReadyState] = useState(false);

  const startPosRef = useRef(new pc.Vec3());
  const endPosRef = useRef(new pc.Vec3());

  const [startTransition, setStartTransition] = useState(false);

  const startPos = useRef(new THREE.Vector3());
  const endPos = useRef(new THREE.Vector3());

  const targetFloorPosition = useRef(new THREE.Vector3());
  const currentFloorRef = useRef("-1");
  const toggleResetRef = useRef(false);

  // const controls = useRef<any>(null);
  // const navigationObject = useRef<Group | null>(null);
  // const firstPersonCameraVector = useRef<Group | null>(null);
  // const thirdPersonCameraVector = useRef<Group | null>(null);

  const isMovingRef = useRef<boolean>(false);
  const isRotatingRef = useRef<boolean>(false);

  const latestPositionJoystickData = useRef<number[]>([0, 0]);
  const latestRotationJoystickData = useRef<number[]>([0, 0]);
  const latestRotationScreenData = useRef<number[]>([0, 0]);

  const latestResetPositionRotationEvent = useRef<number>(0);
  const latestResetOnlyRotationEvent = useRef<number>(0);
  const leaveVenueRef = useRef<number>(0);

  const latestCurrentLevelNameRef = useRef("");

  const initAnimationRef = useRef("init");

  const isSplatLoadingRef = useRef();
  const splatLoadingCountRef = useRef();

  const useQueryParams = () => {
    return useMemo(() => new URLSearchParams(window.location.search), []);
  };

  const DataController = () => {
    const queryParams = useQueryParams();
    let venue = queryParams.get("venue");
    const currentVenue = venue == null || venue == "" ? "xiqu" : venue;

    // const currentVenue = useExplorationStore((state) => state.currentVenue);
    useEffect(() => {
      console.log("init data");

      const mapSetting = getMapSettingByVenueCode(currentVenue);
      setMapSettingState(mapSetting);
      mapSettingRef.current = mapSetting;
      setCurrentVenueName(mapSetting.venueName);

      moveSpeedRef.current = mapSetting.modelConfig.moveSpeed;
      rotateSpeedRef.current = mapSetting.modelConfig.rotateSpeed;
      downSpeedRef.current = mapSetting.modelConfig.downSpeed;

      const floorNamelist = mapSetting.modelConfig.floor
        .filter((f) => f.isNotReady == null)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((f) => f.name);

      const floorShortNamelist = mapSetting.modelConfig.floor
        .filter((f) => f.isNotReady == null)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((f) => f.shortName);

      globalFloorList = floorNamelist;
      globalFloorShortNameList = floorShortNamelist;
      globalVideo = findVenueFullVideo(currentVenue);

      const defaultFloor = mapSetting.modelConfig.floor.find(
        (floor) => floor.lcMapId === mapSetting.modelConfig.defaultLcMapId,
      );

      if (currentLcMapId == "") {
        setCurrentLcMapId(defaultFloor.lcMapId ?? "");
      }
      sendToFlutter({
        type: "venueInfoUpdate",
        floorList: globalFloorList,
        floorShortNameList: globalFloorShortNameList,
        video: globalVideo,
        defaultFloor: defaultFloor?.name ?? floorNamelist[0],
      });

      console.log({
        type: "venueInfoUpdate",
        floorList: globalFloorList,
        floorShortNameList: globalFloorShortNameList,
        video: globalVideo,
        defaultFloor: defaultFloor?.name ?? floorNamelist[0],
      });

      const defaultFloorMapAlign = mapSetting.floorAlignment.find(
        (floor) => floor.lcMapId === mapSetting.modelConfig.defaultLcMapId,
      );

      const scaleFactor = SCALE_BASE / defaultFloorMapAlign.scale;
      modelScaleFactorRef.current = scaleFactor;

      const defaultPosition = new pc.Vec3(
        mapSetting.modelConfig.defaultPosition[0] / scaleFactor,
        mapSetting.modelConfig.defaultPosition[1] / scaleFactor,
        mapSetting.modelConfig.defaultPosition[2] / scaleFactor,
      );

      const defaultTarget = new pc.Vec3(
        mapSetting.modelConfig.defaultTarget[0] / scaleFactor,
        mapSetting.modelConfig.defaultTarget[1] / scaleFactor,
        mapSetting.modelConfig.defaultTarget[2] / scaleFactor,
      );

      const backPosition = getBackPositionWithDistance(
        defaultPosition,
        defaultTarget,
        3,
      );
      topPositionRef.current = new pc.Vec3(
        backPosition.x,
        mapSetting.modelConfig.topAltitude / scaleFactor,
        backPosition.z,
      );
      defaultPositionRef.current = defaultPosition;
      defaultTargetRef.current = defaultTarget;

      setCoordReadyState(true);
    }, []);

    const cameraMode = useExplorationStore((state) => state.cameraMode);
    useEffect(() => {
      latestCameraModeRef.current = cameraMode;
    }, [cameraMode]);

    const currentLcMapId = useExplorationStore((state) => state.currentLcMapId);
    useEffect(() => {
      if (
        currentVenue == null ||
        currentVenue == "" ||
        currentLcMapId == null ||
        currentLcMapId == ""
      ) {
        return;
      }
      const mapSetting = getMapSettingByVenueCode(currentVenue);
      const modelConfigMap = getModelConfigMapByLcMapId(
        mapSetting.modelConfig,
        currentLcMapId,
      );
      const mapAlign = findMapAlignWithLcMapId(
        mapSetting.floorAlignment,
        currentLcMapId,
      );
      modelScaleFactorRef.current = SCALE_BASE / mapAlign.scale;
      const altitude = modelConfigMap.altitude;
      targetAltitudeRef.current = altitude / modelScaleFactorRef.current;
      isLevelChangingRef.current = true;
      currentLcMapIdRef.current = currentLcMapId;
    }, [currentLcMapId, currentVenue]);

    const resetPositionRotationEvent = useExplorationStore(
      (state) => state.resetPositionRotationEvent,
    );
    useEffect(() => {
      latestResetPositionRotationEvent.current = resetPositionRotationEvent;
    }, [resetPositionRotationEvent]);

    const resetOnlyRotationEvent = useExplorationStore(
      (state) => state.resetOnlyRotationEvent,
    );
    useEffect(() => {
      latestResetOnlyRotationEvent.current = resetOnlyRotationEvent;
    }, [resetOnlyRotationEvent]);

    const leaveVenueEvent = useExplorationStore(
      (state) => state.leaveVenueEvent,
    );
    useEffect(() => {
      leaveVenueRef.current = leaveVenueEvent;
    }, [leaveVenueEvent]);

    const positionJoystickData = useExplorationStore(
      (state) => state.positionJoystickData,
    );
    const rotationJoystickData = useExplorationStore(
      (state) => state.rotationJoystickData,
    );

    useEffect(() => {
      latestPositionJoystickData.current = [
        positionJoystickData[0],
        positionJoystickData[1],
      ];
    }, [positionJoystickData]);

    useEffect(() => {
      latestRotationJoystickData.current = [
        rotationJoystickData[0],
        rotationJoystickData[1],
      ];
    }, [rotationJoystickData]);

    return <></>;
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === " ") {
        e.preventDefault(); // Optional: prevent page scroll
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (!coordReadyState || !modelLoadedState) return;

    transitionTimeoutRef.current = setTimeout(() => {
      initAnimationRef.current = "start";
    }, 1000);
  }, [modelLoadedState, coordReadyState]);

  const FloorMeshContainer = () => {
    const baseUrl = getBaseUrl();
    const floorMeshPosition = mapSettingState.modelConfig.floorMeshPosition;
    const floorMeshUrl =
      baseUrl +
      mapSettingState.modelConfig!.folderPath +
      mapSettingState.modelConfig.floorMesh;
    return floorMeshUrl != "" ? (
      <FloorMeshComponent
        floorMeshUrl={floorMeshUrl}
        floorMeshPosition={[
          floorMeshPosition[0] / mapSettingState.modelConfig.scaleFactor,
          floorMeshPosition[1] / mapSettingState.modelConfig.scaleFactor,
          floorMeshPosition[2] / mapSettingState.modelConfig.scaleFactor,
        ]}
        floorMeshScale={[
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
        ]}
      />
    ) : (
      <></>
    );
  };

  const MainCamera = () => {
    const app = useApp();
    let _localProgress;
    let _localCameraMode;
    let isCameraModeUpdated;
    let nearestFixedCameraPosition;

    let finalCameraPosition;
    let finalCameraLookingPosition;

    let lostWallRaycastCount = 0;
    let isForceFirstPersonCamera = false;
    let previousWallBlockingCameraDistance = 0;

    const checkWallBlockingCameraDistance = (expectedCameraPosition) => {
      const rigidbodySystem = app.systems.rigidbody;
      if (!rigidbodySystem || !rigidbodySystem.dynamicsWorld) {
        return;
      }
      const currentPosition = mainObjectEntityRef.current.getPosition().clone();
      const from = new pc.Vec3(
        currentPosition.x,
        currentPosition.y,
        currentPosition.z,
      );
      const to = getNewFrontPosition(
        currentPosition,
        expectedCameraPosition,
        100,
      );
      const hit = rigidbodySystem.raycastFirst(from, to);
      if (hit && hit.entity.name.includes("obstacle")) {
        const distance = currentPosition.z - hit.point.z;
        return Math.abs(distance);
      } else {
        return null;
      }
    };

    const handleUpdate = useCallback((dt: number) => {
      if (cameraScriptRef.current == null) {
        return;
      }

      isCameraModeUpdated = _localCameraMode != latestCameraModeRef.current;
      _localCameraMode = latestCameraModeRef.current;

      if (
        initAnimationRef.current != "free" ||
        isCameraModeUpdated ||
        isMovingRef.current ||
        isRotatingRef.current
      ) {
        const newPosition =
          latestCameraModeRef.current == 0
            ? firstPersonCameraEntityRef.current.getPosition()
            : thirdPersonCameraEntityRef.current.getPosition();


        let wallBlockingCameraDistance =
          checkWallBlockingCameraDistance(newPosition);
        if (
          wallBlockingCameraDistance != null &&
          wallBlockingCameraDistance < THIRD_PERSION_DISTANCE
        ) {
          isForceFirstPersonCamera = true;
          previousWallBlockingCameraDistance = wallBlockingCameraDistance;
        } else {
          if (isForceFirstPersonCamera) {
            lostWallRaycastCount += 1;
            wallBlockingCameraDistance = previousWallBlockingCameraDistance;
          }
          if (lostWallRaycastCount > 100) {
            lostWallRaycastCount = 0;
            isForceFirstPersonCamera = false;
          }
        }
        if (isForceFirstPersonCamera) {
          const adjustDistance =
            wallBlockingCameraDistance - 0.4 < 0
              ? 0
              : wallBlockingCameraDistance - 0.4;
          const adjustedCameraPosition = getNewFrontPosition(
            firstPersonCameraEntityRef.current.getPosition(),
            thirdPersonCameraEntityRef.current.getPosition(),
            adjustDistance,
          );
          newPosition = adjustedCameraPosition;
        }

        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPosition,
        );

        isMovingRef.current = false;
        isRotatingRef.current = false;

        setCameraPosition(newPosition);
        setCameraLookingPosition(mainObjectEntityRef.current.getPosition());
        const cameraAngle = getYAngleDegree(
          newPosition,
          mainObjectEntityRef.current.getPosition(),
        );
        setCameraAngle(cameraAngle);
      }
    }, []);
    useAppEvent("update", handleUpdate);

    useEffect(() => {
      const defaultCameraLookingPosition = new pc.Vec3(
        mapSettingState.modelConfig.defaultPosition[0] /
          mapSettingState.modelConfig.scaleFactor,
        mapSettingState.modelConfig.defaultPosition[1] /
          mapSettingState.modelConfig.scaleFactor,
        mapSettingState.modelConfig.defaultPosition[2] /
          mapSettingState.modelConfig.scaleFactor,
      );
      const defaultPosition = new pc.Vec3(
        mapSettingState.modelConfig.defaultPosition[0] /
          mapSettingState.modelConfig.scaleFactor,
        mapSettingState.modelConfig.defaultPosition[1] /
          mapSettingState.modelConfig.scaleFactor,
        mapSettingState.modelConfig.defaultPosition[2] /
          mapSettingState.modelConfig.scaleFactor -
          1,
      );
      //mainObjectEntityRef.current.setPosition(defaultPosition);
      cameraScriptRef.current.reset(
        defaultCameraLookingPosition,
        defaultPosition,
      );
    }, []);

    return (
      <Entity name="MainCamera">
        <Camera />
        <Script
          ref={cameraScriptRef}
          script={CameraControls}
          enableFly={false}
        />
      </Entity>
    );
  };

  const MainObject = () => {
    const app = useApp();
    const avatarEntityRef = useRef(null);
    const previousHit = useRef();

    let goDownAnimationTime = 0;
    const goDownDuration = 3;

    let goUpAnimationTime = 0;
    const goUpDuration = 2;

    const eulerRef = useRef(new pc.Vec3(0, 180, 0));
    let _localResetPositionRotationEvent = 0;
    let _localResetOnlyRotationEvent = 0;
    let _localLeaveVenueEvent = 0;

    useEffect(() => {
      mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
    }, []);

    const adjustPositionWithRaycast = () => {
      const rigidbodySystem = app.systems.rigidbody;
      if (!rigidbodySystem || !rigidbodySystem.dynamicsWorld) {
        return;
      }
      if (isLevelChangingRef.current) {
        previousHit.current = null;
      }
      const currentPosition = mainObjectEntityRef.current.getPosition().clone();
      const from = new pc.Vec3(
        currentPosition.x,
        currentPosition.y + 100,
        currentPosition.z,
      );
      const to = new pc.Vec3(
        currentPosition.x,
        currentPosition.y - 100,
        currentPosition.z,
      );
      const hit = rigidbodySystem.raycastFirst(from, to);
      if (hit && hit.entity.name.includes("ground")) {
        //console.log(hit.point);
        const verticalDistance = currentPosition.y - hit.point.y;
        if (verticalDistance < 20) {
          const adjustedPosition = new pc.Vec3(
            hit.point.x,
            hit.point.y + 1,
            hit.point.z,
          );
          mainObjectEntityRef.current.setPosition(adjustedPosition);
          previousHit.current = hit;
        }
        //const verticalDistance = camPos.y - hit.point.y;
        // use ref/state here, avoid console.log every frame
      } else if (previousHit.current) {
        const adjustedPosition = new pc.Vec3(
          currentPosition.x,
          previousHit.current.point.y + 1,
          currentPosition.z,
        );
        mainObjectEntityRef.current.setPosition(adjustedPosition);
      }
    };

    const handleUpdate = useCallback((dt: number) => {
      if (mainObjectEntityRef.current == null) {
        return;
      }

      let isResetPositionRotation =
        _localResetPositionRotationEvent !=
        latestResetPositionRotationEvent.current;
      _localResetPositionRotationEvent =
        latestResetPositionRotationEvent.current;

      let isResetOnlyRotation =
        _localResetOnlyRotationEvent != latestResetOnlyRotationEvent.current;
      _localResetOnlyRotationEvent = latestResetOnlyRotationEvent.current;

      let isLeaveVenue = _localLeaveVenueEvent != leaveVenueRef.current;
      _localLeaveVenueEvent = leaveVenueRef.current;

      if (initAnimationRef.current == "init") {
        mainObjectEntityRef.current.setPosition(topPositionRef.current);
        mainObjectEntityRef.current.lookAt(defaultPositionRef.current);
      } else if (initAnimationRef.current == "start") {
        if (goDownAnimationTime >= goDownDuration) {
          mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
          mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
          adjustPositionWithRaycast();
          initAnimationRef.current = "free";
          return;
        }
        goDownAnimationTime += dt;
        const t = Math.min(goDownAnimationTime / goDownDuration, 1);
        const newPos = new pc.Vec3().lerp(
          topPositionRef.current,
          defaultPositionRef.current,
          t,
        );
        mainObjectEntityRef.current.setPosition(newPos);
        const lookTarget = new pc.Vec3().lerp(
          defaultPositionRef.current,
          defaultTargetRef.current,
          t,
        );
        mainObjectEntityRef.current.lookAt(lookTarget); // now safe, position is already set
      } else if (initAnimationRef.current == "free") {
        if (latestPositionJoystickData.current.length != 2) {
          return;
        }

        if (isLevelChangingRef.current) {
          isMovingRef.current = true;
          const targetPosition = new pc.Vec3(
            mainObjectEntityRef.current.getPosition().x,
            targetAltitudeRef.current,
            mainObjectEntityRef.current.getPosition().z,
          );
          const distance = vec3Distance(
            mainObjectEntityRef.current.getPosition(),
            targetPosition,
          );
          const positionAlpha = Math.min(1, (3 * dt) / distance);
          mainObjectEntityRef.current.setPosition(targetPosition);
          isLevelChangingRef.current = false;
          triggerResetPositionRotationEvent();
        }

        if (
          latestPositionJoystickData.current[0] != 0 ||
          latestPositionJoystickData.current[1] != 0
        ) {
          isMovingRef.current = true;
          const worldMat = mainObjectEntityRef.current.getWorldTransform();
          const forward = new pc.Vec3(0, 0, -1);
          worldMat.transformVector(forward, forward);
          forward.y = 0;
          forward.normalize();
          const up = pc.Vec3.UP.clone();
          const right = new pc.Vec3();
          right.cross(up, forward).normalize();
          const forwardScale =
            latestPositionJoystickData.current[1] * moveSpeedRef.current * -dt;
          const rightScale =
            latestPositionJoystickData.current[0] * moveSpeedRef.current * -dt;
          const forwardMove = forward.clone().mulScalar(forwardScale);
          const rightMove = right.clone().mulScalar(rightScale);
          const move = new pc.Vec3();
          move.add(forwardMove).add(rightMove);
          mainObjectEntityRef.current.translate(move);
          adjustPositionWithRaycast();
        }

        if (
          latestRotationJoystickData.current[0] != 0 ||
          latestRotationJoystickData.current[1] != 0
        ) {
          isRotatingRef.current = true;

          eulerRef.current.y +=
            -latestRotationJoystickData.current[0] *
            rotateSpeedRef.current *
            dt; // Yaw
          eulerRef.current.x +=
            -latestRotationJoystickData.current[1] *
            rotateSpeedRef.current *
            dt; // Pitch

          eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
          eulerRef.current.y = wrapAngle(eulerRef.current.y);

          mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
        }

        if (
          latestRotationScreenData.current[0] != 0 ||
          latestRotationScreenData.current[1] != 0
        ) {
          isRotatingRef.current = true;

          eulerRef.current.y +=
            -latestRotationScreenData.current[0] * rotateSpeedRef.current * dt; // Yaw
          eulerRef.current.x +=
            -latestRotationScreenData.current[1] * rotateSpeedRef.current * dt; // Pitch

          eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
          eulerRef.current.y = wrapAngle(eulerRef.current.y);

          mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
        }

        // handle reset
        if (isResetPositionRotation) {
          isMovingRef.current = true;
          isRotatingRef.current = true;

          const floorData = getModelConfigMapByLcMapId(
            mapSettingState.modelConfig,
            currentLcMapIdRef.current,
          );
          if (
            floorData != null &&
            floorData.defaultPosition != null &&
            floorData.defaultTarget != null
          ) {
            const resetPosition = new pc.Vec3(
              floorData.defaultPosition[0] / modelScaleFactorRef.current,
              floorData.defaultPosition[1] / modelScaleFactorRef.current,
              floorData.defaultPosition[2] / modelScaleFactorRef.current,
            );
            const resetTarget = new pc.Vec3(
              floorData.defaultTarget[0] / modelScaleFactorRef.current,
              floorData.defaultTarget[1] / modelScaleFactorRef.current,
              floorData.defaultTarget[2] / modelScaleFactorRef.current,
            );
            mainObjectEntityRef.current.setPosition(resetPosition);
            const targetAngle = getYAngleDegree(resetPosition, resetTarget);
            eulerRef.current.x = 0;
            eulerRef.current.y = -targetAngle + 180;
            eulerRef.current.z = 0;
            mainObjectEntityRef.current.setLocalEulerAngles(
              eulerRef.current.x,
              eulerRef.current.y,
              eulerRef.current.z,
            );
          } else {
            mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
            mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
          }
          adjustPositionWithRaycast();
        }
        if (isResetOnlyRotation) {
          isRotatingRef.current = true;
          eulerRef.current.x = 0;
          mainObjectEntityRef.current.setLocalEulerAngles(
            eulerRef.current.x,
            eulerRef.current.y,
            eulerRef.current.z,
          );
        }
        if (isLeaveVenue) {
          mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
          mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
          adjustPositionWithRaycast();
          initAnimationRef.current = "ending";
        }
      } else if (initAnimationRef.current == "ending") {
        console.log("ending");
        if (goUpAnimationTime >= goUpDuration) {
          mainObjectEntityRef.current.setPosition(topPositionRef.current);
          mainObjectEntityRef.current.lookAt(defaultPositionRef.current);
          adjustPositionWithRaycast();
          return;
        }
        goUpAnimationTime += dt;
        const t = Math.min(goUpAnimationTime / goUpDuration, 1);
        const newPos = new pc.Vec3().lerp(
          defaultPositionRef.current,
          topPositionRef.current,
          t,
        );
        mainObjectEntityRef.current.setPosition(newPos);
        const lookTarget = new pc.Vec3().lerp(
          defaultTargetRef.current,
          defaultPositionRef.current,
          t,
        );
        mainObjectEntityRef.current.lookAt(lookTarget); // now safe, position is already set
        adjustPositionWithRaycast();
      }

      if (avatarEntityRef.current) {
        avatarEntityRef.current.enabled = latestCameraModeRef.current == 1;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={mainObjectEntityRef}>
        <Entity ref={avatarEntityRef}>
          <RobotAvatar
            avatarUrl={mapSettingState.avatar}
            isFloating={mapSettingState.avatarIsFloating}
          />
        </Entity>
        <Entity
          ref={firstPersonCameraEntityRef}
          position={[0, 0, 0.5]}
        ></Entity>
        <Entity
          ref={thirdPersonCameraEntityRef}
          position={[0, 0.5, THIRD_PERSION_DISTANCE]}
        ></Entity>
      </Entity>
    );
  };

  const MeshModels = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    return (
      <>
        {mapSettingState.modelConfig!.mesh.meshModels.map((item, index) => (
          <Fragment key={item.index}>
            <MeshModelComponent
              app={app}
              cameraName={"MainCamera"}
              meshUrl={
                baseUrl + mapSettingState.modelConfig!.folderPath + item.url
              }
              meshPosition={[
                item.position[0] / mapSettingState.modelConfig.scaleFactor,
                item.position[1] / mapSettingState.modelConfig.scaleFactor,
                item.position[2] / mapSettingState.modelConfig.scaleFactor,
              ]}
              meshRotationAngle={item.rotationAngle}
              meshScale={[
                item.scale[0] / mapSettingState.modelConfig.scaleFactor,
                item.scale[1] / mapSettingState.modelConfig.scaleFactor,
                item.scale[2] / mapSettingState.modelConfig.scaleFactor,
              ]}
              meshColor={item.color ?? "#FFFFFF"}
              meshOpacity={item.opacity ?? 1}
              rotateObjects={item.rotateObjects ?? []}
            />
          </Fragment>
        ))}
      </>
    );
  };

  const SingleLod = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const isSplatReadyRef = useRef(false);
    const worstLevelRef = useRef(2);
    const lodLink =
      baseUrl +
      mapSettingState.modelConfig!.folderPath +
      mapSettingState.modelConfig!.splat?.singleLod;

    const splatFirstFrameHandler = (camera, layer, ready, loadingCount) => {
      if (ready && loadingCount == 0) {
        app.systems.gsplat.off("frame:ready", splatFirstFrameHandler);
        afterFirstFrameReady();
      }
    };

    const callbackAssetReadyFunction = (splat, asset) => {
      gsplatAllRef.current["single"] = splat;
      console.log("single lod ready !!!!!!!!!");
      splat.gsplat.enabled = true;
      const worstLevel =
        splat.gsplat.resource?.octree?.lodLevels != null
          ? splat.gsplat.resource?.octree?.lodLevels - 1
          : 0;
      worstLevelRef.current = worstLevel;
      splat.gsplat.lodRangeMin = worstLevel;
      splat.gsplat.lodRangeMax = worstLevel;
      app.systems.gsplat.on("frame:ready", splatFirstFrameHandler);
      return () =>
        app.systems.gsplat.off("frame:ready", splatFirstFrameHandler);
    };

    const afterFirstFrameReady = () => {
      console.log("after single lod first frame ready");
      gsplatAllRef.current["single"].gsplat.lodRangeMin = 0;
      gsplatAllRef.current["single"].gsplat.lodRangeMax = worstLevelRef.current;
      isSplatReadyRef.current = true;
      setModelLoadedState(true);
      // enableXRayMode();
    };

    return (
      <SplatLodComponent
        app={app}
        url={lodLink}
        position={[0, 0, 0]}
        rotation={[180, 0, 0]}
        scale={[
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
        ]}
        lodDistances={mapSettingState.modelConfig.scaleFactor}
        callbackReady={callbackAssetReadyFunction}
      />
    );
  };

  const FloorLod = () => {
    {
      return (
        <>
          {mapSettingState.modelConfig!.floor.map((item, index) =>
            item.lod ? (
              <Fragment key={index}>
                <EachFloorLod floorSetting={item} />
              </Fragment>
            ) : (
              <Fragment key={index}></Fragment>
            ),
          )}
        </>
      );
    }
  };

  const EachFloorLod = ({ floorSetting }) => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const assetModel = useRef();
    const isSplatReadyRef = useRef(false);
    const targetLodRangeMinRef = useRef(2);
    const worstLevelRef = useRef(2);
    const lodLink =
      baseUrl + mapSettingState.modelConfig!.folderPath + floorSetting.lod;

    const mapAlign = findMapAlignWithLcMapId(
      mapSettingState.floorAlignment,
      floorSetting.lcMapId,
    );
    const scaleFactor = SCALE_BASE / mapAlign.scale;

    const currentLcMapId = useExplorationStore((state) => state.currentLcMapId);

    const handleUpdate = useCallback((dt: number) => {
      if (!isSplatReadyRef.current) {
        return;
      }
      if (
        !gsplatAllRef.current[floorSetting.lcMapId] ||
        !gsplatAllRef.current[floorSetting.lcMapId].gsplat
      ) {
        return;
      }
      if (floorSetting.lcMapId == currentLcMapIdRef.current) {
        splatDisplayFloor.current = floorSetting.displayLod;
      }

      if (
        gsplatAllRef.current[floorSetting.lcMapId] == null ||
        splatDisplayFloor.current == null
      ) {
        return;
      }
      if (splatDisplayFloor.current.includes(floorSetting.lcMapId)) {
        if (!gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled) {
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled = true;
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.asset =
            assetModel.current;
        } else {
          if (
            gsplatAllRef.current[floorSetting.lcMapId].gsplat.lodRangeMin >
            targetLodRangeMinRef.current
          ) {
            //When current LOD is above 0 , wait for the current LOD display (e.g. LOD 2) and set the to higher quality LOD
            if (
              !isSplatLoadingRef.current &&
              splatLoadingCountRef.current == 0
            ) {
              gsplatAllRef.current[floorSetting.lcMapId].gsplat.lodRangeMin =
                targetLodRangeMinRef.current;
              if (targetLodRangeMinRef.current > 0) {
                setTimeout(() => {
                  targetLodRangeMinRef.current -= 1;
                }, 500);
              }
            }
          }
        }
      } else {
        if (gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled) {
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled = false;
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.asset = null;
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.lodRangeMin = 2;
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.lodRangeMax = 2;
        }
      }
    }, []);
    useAppEvent("update", handleUpdate);

    const splatFirstFrameHandler = (camera, layer, ready, loadingCount) => {
      if (ready && loadingCount == 0) {
        app.systems.gsplat.off("frame:ready", splatFirstFrameHandler);
        afterFirstFrameReady();
      }
    };

    const callbackAssetReadyFunction = (splat, asset) => {
      console.log("assets ready " + floorSetting.lcMapId);
      gsplatAllRef.current[floorSetting.lcMapId] = splat;
      assetModel.current = asset;
      splat.gsplat.enabled = true;
      const worstLevel =
        splat.gsplat.resource?.octree?.lodLevels != null
          ? splat.gsplat.resource?.octree?.lodLevels - 1
          : 0;
      worstLevelRef.current = worstLevel;
      splat.gsplat.lodRangeMin = worstLevel;
      splat.gsplat.lodRangeMax = worstLevel;
      targetLodRangeMinRef.current =
        worstLevel > 0 ? worstLevel - 1 : worstLevel;
      app.systems.gsplat.on("frame:ready", splatFirstFrameHandler);
      return () =>
        app.systems.gsplat.off("frame:ready", splatFirstFrameHandler);
    };

    const afterFirstFrameReady = () => {
      console.log("after first frame ready " + floorSetting.lcMapId);
      isSplatReadyRef.current = true;
      setModelLoadedState(true);
      //enableXRayMode();
    };

    return (
      <>
        {currentLcMapId == floorSetting.lcMapId ? (
          <SplatLodComponent
            app={app}
            url={lodLink}
            position={[0, floorSetting.yAxis / scaleFactor, 0]}
            rotation={[180, 0, 0]}
            scale={[1 / scaleFactor, 1 / scaleFactor, 1 / scaleFactor]}
            lodDistances={scaleFactor}
            callbackReady={callbackAssetReadyFunction}
          />
        ) : (
          <></>
        )}
      </>
    );
  };

  const Splat = () => {
    return (
      <>
        {mapSettingState.modelConfig!.splat?.mode == "singleLod" ? (
          <SingleLod />
        ) : mapSettingState.modelConfig!.splat?.mode == "floorLod" ? (
          <FloorLod />
        ) : (
          <></>
        )}
      </>
    );
  };

  const WebviewDataController = () => {
    const handleUpdate = useCallback((dt: number) => {
      if (
        globalCurrentFloor != "" &&
        latestCurrentLevelNameRef.current != globalCurrentFloor
      ) {
        //find name
        const newFloor = mapSettingRef.current.modelConfig?.floor?.find(
          (f) => f.name === globalCurrentFloor,
        );
        setCurrentLcMapId(newFloor.lcMapId);
        // setCurrentLevel(globalCurrentFloor);
      }
    }, []);
    useAppEvent("update", handleUpdate);
    return <></>;
  };

  const AllFloorMeshGround = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    return (
      <>
        {mapSettingState.modelConfig!.floor.map((item, index) => {
          if (!item.meshGround) {
            return null;
          }
          const mapAlign = findMapAlignWithLcMapId(
            mapSettingState.floorAlignment,
            item.lcMapId,
          );
          const scaleFactor = SCALE_BASE / mapAlign.scale;
          const meshY = item.yAxis / scaleFactor;
          const meshGroundUrl =
            baseUrl +
            mapSettingState.modelConfig!.folderPath +
            (item.meshGround ?? "");
          const meshObstacleUrl =
            baseUrl +
            mapSettingState.modelConfig!.folderPath +
            (item.meshObstacle ?? "");

          return (
            <Fragment key={item.lcMapId}>
              {item.meshGround ? (
                <>
                  <EachFloorMesh
                    app={app}
                    lcMapId={item.lcMapId}
                    meshUrl={meshGroundUrl}
                    meshPosition={[0, meshY, 0]}
                    meshRotation={[0, 180, 0]}
                    meshScale={[
                      1 / scaleFactor,
                      1 / scaleFactor,
                      1 / scaleFactor,
                    ]}
                  />
                </>
              ) : (
                <></>
              )}
              {item.meshObstacle ? (
                <>
                  <EachFloorMesh
                    app={app}
                    lcMapId={item.lcMapId}
                    meshUrl={meshObstacleUrl}
                    meshPosition={[0, meshY, 0]}
                    meshRotation={[0, 180, 0]}
                    meshScale={[
                      1 / scaleFactor,
                      1 / scaleFactor,
                      1 / scaleFactor,
                    ]}
                  />
                </>
              ) : (
                <></>
              )}
            </Fragment>
          );
        })}
      </>
    );
  };

  const EachFloorMesh = ({
    app,
    type,
    lcMapId,
    meshUrl,
    meshPosition,
    meshRotation,
    meshScale,
  }: {
    app: any;
    type: string;
    lcMapId: string;
    meshUrl: string;
    meshPosition: number[];
    meshRotation: number[];
    meshScale: number[];
  }) => {
    const [isFirstDisplayedState, setIsFirstDisplayedState] =
      useState<boolean>(false);
    const isFirstDisplayedRef = useRef<boolean>(false);
    const meshOpacity = 1;
    const meshEntityRef = useRef();
    const meshInnerEntityRef = useRef();
    const isCollisionSetRef = useRef();
    const { asset: meshAsset } = useModel(meshUrl);
    const enableCollision = () => {
      if (
        isFirstDisplayedRef.current &&
        meshInnerEntityRef.current?.collision != null &&
        meshAsset != null
      ) {
        meshInnerEntityRef.current.collision.type = "mesh";
        meshInnerEntityRef.current.collision.renderAsset =
          meshAsset.resource.renders[0];
        isCollisionSetRef.current = true;
      } else {
        requestAnimationFrame(() => {
          enableCollision();
        });
      }
    };
    useEffect(() => {
      if (meshAsset && meshEntityRef.current) {
        meshEntityRef.current.enabled = false;
        requestAnimationFrame(() => {
          enableCollision();
        });
      }
    }, [meshAsset]);

    const handleUpdate = useCallback((dt: number) => {
      meshEntityRef.current.enabled = currentLcMapIdRef.current == lcMapId;
      if (
        currentLcMapIdRef.current == lcMapId &&
        !isFirstDisplayedRef.current
      ) {
        setIsFirstDisplayedState(true);
        isFirstDisplayedRef.current = true;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity
        ref={meshEntityRef}
        name={"FloorMesh_" + lcMapId}
        position={meshPosition}
        rotation={meshRotation}
        scale={meshScale}
        enabled={false}
      >
        {isFirstDisplayedState ? (
          <Entity ref={meshInnerEntityRef} name={type + "_" + lcMapId}>
            <RigidBody type="static" />
            <Collision type="box" convexHull={false} />
            {/*
              <Render type="asset" asset={meshAsset} />
            */}
          </Entity>
        ) : (
          <></>
        )}
      </Entity>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();

    useEffect(() => {
      const splatLoadingUpdate = (camera, layer, ready, loadingCount) => {
        isSplatLoadingRef.current = !ready;
        splatLoadingCountRef.current = loadingCount;
      };
      if (app && app?.systems?.gsplat != null) {
        app.systems.gsplat.on("frame:ready", splatLoadingUpdate);
      }
      return () => {
        if (app && app?.systems?.gsplat != null) {
          app.systems.gsplat.off("frame:ready", splatLoadingUpdate);
        }
      };
    }, [app]);

    return (
      <>
        {mapSettingState.modelConfig!.splat ? <Splat /> : <></>}
        {mapSettingState.modelConfig!.mesh ? <MeshModels /> : <></>}
        {mapSettingState.modelConfig!.floorMesh ? (
          <FloorMeshContainer />
        ) : (
          <></>
        )}

        {mapSettingState.modelConfig!.floor ? <AllFloorMeshGround /> : <></>}

        <MainObject />
        <MainCamera />
        <WebviewDataController />
      </>
    );
  };

  const Scene = () => {
    return (
      <Application
        usePhysics={true}
        maxDeltaTime={0.033}
        timeScale={1.0}
        graphicsDeviceOptions={{
          powerPreference: "default",
          alpha: false,
          antialias: false,
          preferWebGl2: true,
          stencil: false,
        }}
      >
        {mapSettingState != null && mapSettingState.modelConfig != null ? (
          <PlaycanvasScene />
        ) : (
          <></>
        )}
      </Application>
    );
  };

  console.log(
    "ExplorationPage component rendered , if this keep showing, something wrong",
  );

  const DragController = () => {
    const isDraggingRef = useRef(false);
    const startPosRef = useRef({ x: 0, y: 0 });
    const previousPositionRef = useRef({ x: 0, y: 0 });
    const getClientPos = (e) => {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    };
    const handleStart = useCallback((e) => {
      const pos = getClientPos(e);
      isDraggingRef.current = true;
      previousPositionRef.current = { x: pos.x, y: pos.y };
    }, []);
    const handleMove = useCallback((e) => {
      if (!isDraggingRef.current) {
        return;
      }
      const pos = getClientPos(e);
      const xChange = pos.x - previousPositionRef.current.x;
      const yChange = pos.y - previousPositionRef.current.y;
      previousPositionRef.current = { x: pos.x, y: pos.y };
      latestRotationScreenData.current[0] = xChange * 0.5;
      latestRotationScreenData.current[1] = yChange * 0.5;
    }, []);
    const handleEnd = useCallback(() => {
      isDraggingRef.current = false;
      latestRotationScreenData.current[0] = 0;
      latestRotationScreenData.current[1] = 0;
    }, []);
    useEffect(() => {
      window.addEventListener("mouseup", handleEnd);
      window.addEventListener("touchend", handleEnd);
      return () => {
        window.removeEventListener("mouseup", handleEnd);
        window.removeEventListener("touchend", handleEnd);
      };
    }, []);

    return (
      <div
        className="fullscreen_div"
        onMouseDown={handleStart}
        onTouchStart={handleStart}
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseUp={handleEnd}
        onTouchEnd={handleEnd}
      ></div>
    );
  };

  return (
    <div
      className="absolute top-0 left-0 w-full h-full"
      style={{ backgroundColor: "black" }}
    >
      <DataController />
      <Scene />
      <DragController />
      <WatermarkScreen />
    </div>
  );
}
